import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, EffectFade, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { useRef } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { supabase } from "../supabaseClient";
import { FiStar } from "react-icons/fi";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import SEOHelmet, {
  siteUrl,
  websiteSchema,
  buildBreadcrumb,
  buildServiceSchema,
} from "../components/SEOHelmet";
import blogsData from "../data/blogs.json";


const Home = () => {
  const [reviews, setReviews] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [youtubeVideos, setYoutubeVideos] = useState([]);
  const [youtubeLoading, setYoutubeLoading] = useState(true);
  const [heroLoading, setHeroLoading] = useState(true);
  const [heroImages, setHeroImages] = useState([]);
  const [typedText, setTypedText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [titleIndex, setTitleIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    location: "",
    email: "",
    description: "",
  });

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const aboutPrevRef = useRef(null);
  const aboutNextRef = useRef(null);
  const feedbackPrevRef = useRef(null);
  const feedbackNextRef = useRef(null);



  const typingSpeed = isDeleting ? 50 : 80;
  const pauseAfterComplete = 2000;

  const titles = heroImages.length > 0 ? heroImages.map((hero) => hero.title) : ["Welcome to Baby Twinkles"];
  const currentTitle = titles[titleIndex];
  useEffect(() => {

    if (isDeleting) {
      if (currentIndex > 0) {
        const timeout = setTimeout(() => {
          setTypedText((prev) => prev.slice(0, -1));
          setCurrentIndex((prev) => prev - 1);
        }, typingSpeed);
        return () => clearTimeout(timeout);
      } else {
        setIsDeleting(false);
        setTitleIndex((prev) => (prev + 1) % titles.length);
      }
    } else {
      if (currentIndex < currentTitle.length) {
        const timeout = setTimeout(() => {
          setTypedText((prev) => prev + currentTitle[currentIndex]);
          setCurrentIndex((prev) => prev + 1);
        }, typingSpeed);
        return () => clearTimeout(timeout);
      } else {
        const timeout = setTimeout(() => {
          setIsDeleting(true);
        }, pauseAfterComplete);
        return () => clearTimeout(timeout);
      }
    }
  }, [currentIndex, isDeleting, currentTitle, titles.length]);

  const fetchReviews = async () => {
    try {
      const { data, error } = await supabase
        .from("reviews")
        .select("*")
        .order("created_at", { ascending: false });

      if (error) throw error;
      setReviews(data || []);
    } catch (err) {
      console.error("Error fetching reviews:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchGalleryImages = async () => {
    try {
      const { data, error } = await supabase
        .from("photos")
        .select("*")
        .order("created_at", { ascending: false })
        .limit(12)
      if (error) throw error;
      setGalleryImages(data || []);
    } catch (err) {
      console.error("Error fetching gallery images:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchYoutubeVideos = async () => {
    try {
      const { data, error } = await supabase
        .from("youtube")
        .select("*")
        .order("created_at", { ascending: false })
        .limit(6);

      if (error) throw error;
      setYoutubeVideos(data || []);
    } catch (err) {
      console.error("Error fetching YouTube videos:", err);
    } finally {
      setYoutubeLoading(false);
    }
  };

  const fetchHeroImages = async () => {
    try {
      const { data, error } = await supabase
        .from("hero_section")
        .select("*")
        .order("created_at", { ascending: false });

      if (error) throw error;
      
      if (data && data.length > 0) {
        setHeroImages(data);
      } else {
        setHeroImages([
          {
            id: 1,
            image_url: "/assets/img/babies/hero1.png",
            title: "Welcome to Baby Twinkles Photography"
          },
          
        ]);
      }
    } catch (err) {
      setHeroImages([
        {
          id: 1,
          image_url: "/assets/img/babies/hero1.png",
          title: "Welcome to Baby Twinkles Photography"
        },
      
      ]);
    } finally {
      setHeroLoading(false);
    }
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });

    Fancybox.bind("[data-fancybox]", {
      Toolbar: true,
      buttons: ["slideShow", "thumbs", "zoom", "fullscreen", "close"],
    });

    fetchGalleryImages();
    fetchYoutubeVideos();
    fetchReviews();
    fetchHeroImages();
  }, []);

  const getInitials = (title) => {
    if (!title) return "?";
    const words = title.trim().split(/\s+/);
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }
    return title[0].toUpperCase();
  };

  const getAvatarColor = (title) => {
    if (!title) return "#7c3aed";
    const colors = [
      "#7c3aed",
      "#ec4899",
      "#f59e0b",
      "#10b981",
      "#3b82f6",
      "#ef4444",
    ];
    const index = title.charCodeAt(0) % colors.length;
    return colors[index];
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const message = `*New Inquiry from Baby Twinkles Photography Website*

*Name:* ${formData.name}
*Phone:* ${formData.phone}
*Location:* ${formData.location}
${formData.email ? `*Email:* ${formData.email}` : ""}
${formData.description ? `*Description:* ${formData.description}` : ""}`;

    const whatsappNumber = "918074597649";
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    
    window.open(whatsappUrl, "_blank");

    setFormData({
      name: "",
      phone: "",
      location: "",
      email: "",
      description: "",
    });
  };

  return (
    <>
      {heroLoading ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "white",
            zIndex: 9999,
          }}
        >
          <div style={{backgroundColor: 'white', width: '100px', height: '100px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img src="/assets/img/logo.png" alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '50%', backgroundColor:"black" }} />
          </div>
        </div>
      ) : (
    <div style={{ overflowX: "hidden" }}>
      
      <SEOHelmet
        title="Best Baby & Newborn Photographer in Hyderabad | Book a Session"
        description="Baby Twinkles Photography – Hyderabad's #1 professional baby & newborn photography studio in Madhapur. Specializing in newborn shoots, cake smash, milestone, maternity & family portraits. Call +91 8074 597 649 to book!"
        keywords="baby photographer Hyderabad, newborn photography Hyderabad, best baby photoshoot Hyderabad, cake smash photographer Hyderabad, milestone photography Hyderabad, maternity photographer Hyderabad, family photographer Hyderabad, infant photographer Hyderabad, baby photography Madhapur, professional baby photographer near me, newborn photographer near me Hyderabad, baby studio photography Hyderabad, themed baby photoshoot Hyderabad, 1st birthday photographer Hyderabad, baby photography Telangana, newborn photos Hyderabad"
        canonicalUrl={`${siteUrl}/`}
        ogType="website"
        schema={[
          websiteSchema,
          buildBreadcrumb([
            { name: "Home", url: `${siteUrl}/` },
          ]),
          buildServiceSchema(
            "Newborn Photography Hyderabad",
            "Professional newborn photography sessions in Hyderabad within the first 14 days of birth. Peaceful, posed newborn portraits using premium props and wraps.",
            `${siteUrl}/#newborn`
          ),
          buildServiceSchema(
            "Baby Milestone Photography Hyderabad",
            "Capture every precious milestone of your baby's journey – sitter sessions at 6-9 months, first steps, and birthday sessions in Hyderabad.",
            `${siteUrl}/#milestone`
          ),
          buildServiceSchema(
            "Cake Smash Photography Hyderabad",
            "Fun and colourful 1st birthday cake smash photography sessions in Hyderabad for babies. Includes themed setups and professional editing.",
            `${siteUrl}/#cakesmash`
          ),
          buildServiceSchema(
            "Family Portrait Photography Hyderabad",
            "Professional family portrait photography sessions in Hyderabad. Capture the love and bond of your entire family with beautifully curated photos.",
            `${siteUrl}/#family`
          ),
          buildServiceSchema(
            "Maternity Photography Hyderabad",
            "Elegant maternity photography sessions in Hyderabad to celebrate the beauty of pregnancy with stunning portraits.",
            `${siteUrl}/#maternity`
          ),
        ]}
      />
      
      
   <div className="home3-banner-area">
  <Swiper
    className="home3-banner-slider"
    modules={[Navigation, Pagination, EffectFade, Autoplay]}
    slidesPerView={1}
    speed={1500}
    spaceBetween={25}
    effect="fade"
    fadeEffect={{ crossFade: true }}
    loop={true}
    autoplay={{
      delay: 3000,
      disableOnInteraction: false,
    }}
    navigation={{
      prevEl: prevRef.current,
      nextEl: nextRef.current,
    }}
    pagination={{
      el: ".paginations111",
      clickable: true,
    }}
    onBeforeInit={(swiper) => {
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;
    }}
  >
    {heroImages.map((hero) => (
      <SwiperSlide key={hero.id}>
        <div
          className="banner-bg"
          style={{
            backgroundImage: `linear-gradient(
              180deg,
              rgba(0,0,0,0.35) 0%,
              rgba(0,0,0,0.20) 100%
            ), url(${hero.image_url})`,
          }}
        />
      </SwiperSlide>
    ))}
  </Swiper>

  <div className="container-fluid">
    <div className="row">
      <div className="col-lg-12">
        <div className="banner-wrapper">
          <div className="banner-content">
            <h1>
              {typedText}
              <span style={{ animation: "blink 1s infinite" }}>|</span>
            </h1>
          </div>

          <div className="slider-btn-group style-2 style-3 justify-content-md-end justify-content-center gap-4">
            <div
              className="slider-btn prev-4 d-md-flex d-none"
              ref={prevRef}
            >
              <svg
                width={11}
                height={19}
                viewBox="0 0 8 13"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 6.50008L8 0L2.90909 6.50008L8 13L0 6.50008Z" />
              </svg>
            </div>

            <div className="paginations111" />

            <div
              className="slider-btn next-4 d-md-flex d-none"
              ref={nextRef}
            >
              <svg
                width={11}
                height={19}
                viewBox="0 0 8 13"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M8 6.50008L0 0L5.09091 6.50008L0 13L8 6.50008Z" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



      <div className="home4-about-section my-4">
        <div className="container">
          <div className="row g-lg-4 gy-3">
            <div className="col-lg-6">
              <div
                className="about-content-wrap"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="section-title1">
                  <h2>Get To Know About Baby Twinkles Photography</h2>
                </div>
                <p>
                  Capture the precious moments of your little ones with our
                  professional baby photography services. We specialize in
                  newborn, milestone, and family photography, ensuring that
                  every smile and twinkle is preserved forever. Book a session
                  with us to create beautiful memories that will last a
                  lifetime. Our creative team provides a comfortable and safe
                  environment for every photoshoot, making each session
                  enjoyable for both babies and parents. With carefully designed
                  themes, professional lighting, and attention to every detail,
                  we create stunning portraits that tell your family's unique
                  story. Let us turn your cherished moments into timeless works
                  of art that you will treasure for generations.
                </p>
                <div className="about-btn">
                  <Link className="primary-btn3" to="/about">
                    About More
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="about-img-wrap"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <Swiper
                  className="home3-about-img-slider"
                  modules={[Navigation]}
                  slidesPerView={1}
                  spaceBetween={25}
                  navigation={{
                    prevEl: aboutPrevRef.current,
                    nextEl: aboutNextRef.current,
                  }}
                  onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = aboutPrevRef.current;
                    swiper.params.navigation.nextEl = aboutNextRef.current;
                  }}
                >
                  <SwiperSlide>
                    <img src="/assets/img/babies/hero1.png" alt style={{ width: "100%", height: "400px", objectFit: "cover" }} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img src="/assets/img/babies/hero2.png" alt style={{ width: "100%", height: "400px", objectFit: "cover" }} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img src="/assets/img/babies/hero3.png" alt style={{ width: "100%", height: "400px", objectFit: "cover" }} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img src="/assets/img/babies/hero4.png" alt style={{ width: "100%", height: "400px", objectFit: "cover" }} />
                  </SwiperSlide>
                  <div className="slider-btn-group2">
                    <div className="slider-btn prev-6" ref={aboutPrevRef}>
                      <svg
                        width={9}
                        height={15}
                        viewBox="0 0 8 13"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M0 6.50008L8 0L2.90909 6.50008L8 13L0 6.50008Z" />
                      </svg>
                    </div>
                    <div className="slider-btn next-6" ref={aboutNextRef}>
                      <svg
                        width={9}
                        height={15}
                        viewBox="0 0 8 13"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M8 6.50008L0 0L5.09091 6.50008L0 13L8 6.50008Z" />
                      </svg>
                    </div>
                  </div>
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="how-it-work-section mb-4">
        <div className="container">
          <div className="row mb-50" data-aos="fade-up" data-aos-delay="200">
            <div className="col-lg-12 d-flex align-items-end justify-content-between gap-3 flex-wrap">
              <div className="section-title-2">
                <h2>How Does It Work</h2>
                <p>
                  Here is our simple process for booking a photography session
                  with us.
                </p>
              </div>
            </div>
          </div>
          <div className="row " data-aos="fade-up" data-aos-delay="300">
            <div className="col-lg-12">
              <div className="work-process-group">
                <div className="row justify-content-center g-lg-0 gy-5">
                  <div className="col-lg-3 col-sm-6">
                    <div className="single-work-process text-center">
                      <div className="step">
                        <span>01</span>
                      </div>
                      <div className="icon">
                        <img src="assets/img/home2/icon/loaction.svg" alt />
                      </div>
                      <div className="content">
                        <h6>Choose A Package</h6>
                        <p>
                          Select the perfect photography package for your baby's
                          needs.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6">
                    <div className="single-work-process text-center">
                      <div className="step">
                        <span>02</span>
                      </div>
                      <div className="icon">
                        <img src="assets/img/home2/icon/contact.svg" alt />
                      </div>
                      <div className="content">
                        <h6>Book A Session</h6>
                        <p>
                          Contact us to schedule a convenient time for your
                          photoshoot.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6">
                    <div className="single-work-process text-center">
                      <div className="step">
                        <span>03</span>
                      </div>
                      <div className="icon">
                        <img src="assets/img/home2/icon/pay.svg" alt />
                      </div>
                      <div className="content">
                        <h6>Enjoy The Shoot</h6>
                        <p>
                          Relax and have fun while we capture beautiful moments.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6">
                    <div className="single-work-process text-center">
                      <div className="step">
                        <span>04</span>
                      </div>
                      <div className="icon">
                        <img src="assets/img/home2/icon/recieve.svg" alt />
                      </div>
                      <div className="content">
                        <h6>Receive Your Photos</h6>
                        <p>
                          Get your high-quality, professionally edited photos.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="gallery-section py-3">
        <div className="container">
          <div className="row mb-4" data-aos="fade-up" data-aos-delay="200">
            <div className="col-lg-12 text-center">
              <div className="section-title-2">
                <h2>Our Gallery</h2>
                <p>
                  Take a peek into some of our beautiful baby photography
                  sessions.
                </p>
              </div>
            </div>
          </div>
          <div className="row g-2">
            {galleryImages.length === 0 ? (
              <div className="col-12 text-center py-5">
                No gallery images yet.
              </div>
            ) : (
              galleryImages.map((img, index) => (
                <div
                  className="col-lg-2"
                  key={img.id}
                  data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
                  data-aos-delay={100 + index * 100}
                >
                  <a
                    href={img.image_url}
                    data-fancybox="home-gallery"
                  >
                    <div
                      className="gallery-item overflow-hidden border rounded shadow-sm position-relative"
                      style={{
                        cursor: "pointer",
                        height: "200px",
                        width:"100%"
                      }}
                    >
                      <img
                        src={img.image_url}
                        alt={img.title || "Gallery Image"}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          transition: "transform 0.4s ease",
                          display: "block",
                        }}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.transform = "scale(1.08)")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.transform = "scale(1)")
                        }
                      />
                    </div>
                  </a>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
      <div className="milestone-section mb-5">
        <div className="container">
          <div className="row mb-50" data-aos="fade-up" data-aos-delay="200">
            <div className="col-lg-12 text-center">
              <div className="section-title-2">
                <h2>Capturing Every Milestone</h2>
                <p>
                  We are there for every precious step of your baby's journey.
                </p>
              </div>
            </div>
          </div>
          <div className="row g-4">
            <div
              className="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div
                className="single-work-process text-center p-4 shadow-sm"
                style={{ borderRadius: "15px", background: "#fff" }}
              >
                <div className="icon mb-3">
                  <img
                    src="assets/img/home2/icon/contact.svg"
                    alt="Newborn"
                    style={{ width: "60px" }}
                  />
                </div>
                <div className="content">
                  <h5>Newborn Magic</h5>
                  <p>
                    Those sleepy, squishy first days are gone in a blink. We
                    capture the delicate details of your newborn beautifully.
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <div
                className="single-work-process text-center p-4 shadow-sm"
                style={{ borderRadius: "15px", background: "#fff" }}
              >
                <div className="icon mb-3">
                  <img
                    src="assets/img/home2/icon/pay.svg"
                    alt="Sitter"
                    style={{ width: "60px" }}
                  />
                </div>
                <div className="content">
                  <h5>Sitter Sessions</h5>
                  <p>
                    When they start sitting up and showing those bright, gummy
                    smiles! Perfect for the 6-9 month milestone.
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-delay="600"
            >
              <div
                className="single-work-process text-center p-4 shadow-sm"
                style={{ borderRadius: "15px", background: "#fff" }}
              >
                <div className="icon mb-3">
                  <img
                    src="assets/img/home2/icon/recieve.svg"
                    alt="Birthday"
                    style={{ width: "60px" }}
                  />
                </div>
                <div className="content">
                  <h5>1st Birthday</h5>
                  <p>
                    Celebrate their first big milestone with a fun cake smash or
                    a beautiful classic portrait session.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="youtube-section py-3 bg-light">
        <div className="container">
          <div className="row mb-5 text-center">
            <div className="col-12" data-aos="fade-up">
              <div className="section-title-2">
                <h2>Behind the Scenes</h2>
                <p>Watch our favorite moments and behind-the-scenes magic.</p>
              </div>
            </div>
          </div>
          <div className="row g-4">
            {youtubeLoading ? (
              <div className="col-12 text-center py-5">Loading videos...</div>
            ) : youtubeVideos.length === 0 ? (
              <div className="col-12 text-center py-5">No videos yet.</div>
            ) : (
              youtubeVideos.map((video, i) => {
                const videoId = video.youtube_url.match(
                  /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/,
                )?.[1];
                const embedUrl = videoId
                  ? `https://www.youtube.com/embed/${videoId}`
                  : null;
                return (
                  <div
                    className="col-lg-4"
                    key={video.id}
                    data-aos={i % 2 === 0 ? "fade-right" : "fade-left"}
                    data-aos-delay={100 + i * 100}
                  >
                    <div
                      className="video-card rounded-4 overflow-hidden shadow-lg p-2 bg-white"
                      style={{ border: "1px solid #eee" }}
                    >
                      <div
                        className="ratio rounded-3 overflow-hidden"
                        style={{ aspectRatio: "16/9" }}
                      >
                        {embedUrl ? (
                          <iframe
                            src={embedUrl}
                            title={`YouTube video ${i}`}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            style={{ border: 0, width: "100%", height: "100%" }}
                          ></iframe>
                        ) : (
                          <div className="d-flex align-items-center justify-content-center h-100 bg-light">
                            <span className="text-muted">
                              Invalid YouTube URL
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
      <div className="instagram-section py-5">
        <div className="container">
          <div className="row mb-3 text-center">
            <div className="col-12" data-aos="fade-up">
              <div className="section-title-2">
                <h2>Follow Us on Instagram</h2>
                <p>Stay updated with our latest baby photoshoots and reels.</p>
              </div>
            </div>
          </div>
          <div className="row g-4 justify-content-center">
            {[1, 2, 3, 4].map((post, i) => (
              <div
                className="col-lg-3 col-md-6 d-flex justify-content-center"
                key={i}
                data-aos={i % 2 === 0 ? "fade-left" : "fade-right"}
                data-aos-delay={100 + i * 100}
              >
                <a
                  href="https://www.instagram.com/baby_twinkles_photography/?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="instagram-post card shadow-sm w-100"
                  style={{
                    maxWidth: "350px",
                    borderRadius: "8px",
                    border: "1px solid #dbdbdb",
                    fontFamily: "Arial, sans-serif",
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                  <div
                    className="card-header bg-white d-flex align-items-center justify-content-between p-3"
                    style={{ borderBottom: "1px solid #efefef" }}
                  >
                    <div className="d-flex align-items-center">
                      <img
                        src="/assets/img/logo.png"
                        className="rounded-circle me-1"
                        style={{
                          width: "32px",
                          height: "32px",
                          backgroundColor:"black",
                          objectFit: "contain",
                        }}
                        alt="profile"
                      />
                      <span
                        className="fw-bold"
                        style={{ fontSize: "14px", color: "#262626" }}
                      >
                        baby_twinkles_photography
                      </span>
                    </div>
                    <svg
                      aria-label="More options"
                      color="#262626"
                      fill="#262626"
                      height="24"
                      role="img"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <circle cx="12" cy="12" r="1.5"></circle>
                      <circle cx="6" cy="12" r="1.5"></circle>
                      <circle cx="18" cy="12" r="1.5"></circle>
                    </svg>
                  </div>

                  <div
                    className="post-media"
                    style={{
                      width: "100%",
                      height: "200px",
                      backgroundColor: "#fafafa",
                      position: "relative",
                    }}
                  >
                    <img
                      src={
                        i === 0
                          ? "/assets/img/babies/hero1.png"
                          : i === 1
                          ? "/assets/img/babies/hero2.png"
                          : i === 2
                          ? "/assets/img/babies/hero3.png"
                          : "/assets/img/babies/hero4.png"
                      }
                      className="w-100 h-100"
                      style={{ objectFit: "cover" }}
                      alt="post"
                    />
                    <div
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                      }}
                    >
                      <svg
                        aria-label="Reels"
                        color="#ffffff"
                        fill="#ffffff"
                        height="20"
                        role="img"
                        viewBox="0 0 24 24"
                        width="20"
                      >
                        <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10zm4.707-10.428l-6-3.5A.5.5 0 0010 8.5v7a.5.5 0 00.758.428l6-3.5a.5.5 0 000-.856z"></path>
                      </svg>
                    </div>
                  </div>

                  <div className="card-body p-3">
                    <div className="d-flex justify-content-between mb-2">
                      <div className="d-flex gap-3">
                        <svg
                          aria-label="Like"
                          color="#262626"
                          fill="#262626"
                          height="24"
                          role="img"
                          viewBox="0 0 24 24"
                          width="24"
                          style={{ cursor: "pointer" }}
                        >
                          <path
                            d="M16.792 3.904A4.989 4.989 0 0121.5 9.122c0 3.072-2.652 4.959-5.197 7.222-2.512 2.243-3.865 3.469-4.303 3.752-.477-.309-2.143-1.823-4.303-3.752C5.141 14.072 2.5 12.167 2.5 9.122a4.989 4.989 0 014.708-5.218 4.21 4.21 0 013.675 1.941c.84 1.174.98 1.514 1.117 1.514s.277-.34 1.117-1.514a4.21 4.21 0 013.675-1.941z"
                            fill="none"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                          ></path>
                        </svg>
                        <svg
                          aria-label="Comment"
                          color="#262626"
                          fill="#262626"
                          height="24"
                          role="img"
                          viewBox="0 0 24 24"
                          width="24"
                          style={{ cursor: "pointer" }}
                        >
                          <path
                            d="M20.656 17.008a9.993 9.993 0 10-3.59 3.615L22 22z"
                            fill="none"
                            stroke="currentColor"
                            strokeLinejoin="round"
                            strokeWidth="2"
                          ></path>
                        </svg>
                        <svg
                          aria-label="Share Post"
                          color="#262626"
                          fill="#262626"
                          height="24"
                          role="img"
                          viewBox="0 0 24 24"
                          width="24"
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (navigator.share) {
                              navigator.share({
                                title: "Baby Twinkles Photography",
                                text: "Check out Baby Twinkles Photography for amazing baby photoshoots!",
                                url: "https://www.instagram.com/baby_twinkles_photography/?hl=en"
                              }).catch((error) => console.log("Error sharing:", error));
                            } else {
                              alert("Sharing not supported on this browser");
                            }
                          }}
                        >
                          <line
                            fill="none"
                            stroke="currentColor"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            x1="22"
                            x2="9.218"
                            y1="3"
                            y2="10.083"
                          ></line>
                          <polygon
                            fill="none"
                            points="11.698 20.334 22 3.001 2 3.001 9.218 10.084 11.698 20.334"
                            stroke="currentColor"
                            strokeLinejoin="round"
                            strokeWidth="2"
                          ></polygon>
                        </svg>
                      </div>
                      <div>
                        <svg
                          aria-label="Save"
                          color="#262626"
                          fill="#262626"
                          height="24"
                          role="img"
                          viewBox="0 0 24 24"
                          width="24"
                          style={{ cursor: "pointer" }}
                        >
                          <polygon
                            fill="none"
                            points="20 21 12 13.44 4 21 4 3 20 3 20 21"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                          ></polygon>
                        </svg>
                      </div>
                    </div>
                    <div
                      className="likes fw-bold mb-1"
                      style={{ fontSize: "14px", color: "#262626" }}
                    >
                      8,492 likes
                    </div>
                    <div
                      className="caption"
                      style={{ fontSize: "14px", color: "#262626" }}
                    >
                      <span className="fw-bold me-2">
                        baby_twinkles_photography
                      </span>
                      Capturing the sweetest smiles and tiniest toes! 👶✨
                      #babyphotography #newborn
                    </div>
                    <div
                      className="comments text-muted mt-1"
                      style={{ fontSize: "14px" }}
                    >
                      View all 124 comments
                    </div>
                    <div
                      className="time text-muted mt-1"
                      style={{ fontSize: "10px", textTransform: "uppercase" }}
                    >
                      2 HOURS AGO
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>{" "}
      <div className="customar-feedback-area mb-2 ">
        <div className="container">
          <div className="row mb-3" data-aos="fade-up" data-aos-delay="200">
            <div className="col-lg-12">
              <div className="section-title1">
                <span>Customer Feedback</span>
                <h2>What Our Customers Are Saying</h2>
              </div>
            </div>
          </div>
          <div className="row g-4 mb-4">
            <div className="col-lg-12" data-aos="fade-up" data-aos-delay="200">
              <div className="customer-feedback-right">
                <Swiper
                  className="customer-feedback-slider mb-3"
                  modules={[Navigation, Autoplay]}
                  slidesPerView={1}
                  speed={1500}
                  spaceBetween={25}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                  navigation={{
                    prevEl: feedbackPrevRef.current,
                    nextEl: feedbackNextRef.current,
                  }}
                  onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = feedbackPrevRef.current;
                    swiper.params.navigation.nextEl = feedbackNextRef.current;
                  }}
                  breakpoints={{
                    280: {
                      slidesPerView: 1,
                    },
                    386: {
                      slidesPerView: 1,
                    },
                    576: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                      spaceBetween: 15,
                    },
                    992: {
                      slidesPerView: 3,
                      spaceBetween: 15,
                    },
                    1200: {
                      slidesPerView: 3,
                      spaceBetween: 15,
                    },
                    1400: {
                      slidesPerView: 3,
                    },
                  }}
                >
                  {loading ? (
                    <div style={{ textAlign: "center", padding: "40px" }}>
                      Loading reviews...
                    </div>
                  ) : reviews.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "40px" }}>
                      No reviews yet.
                    </div>
                  ) : (
                    reviews.map((review) => (
                      <SwiperSlide key={review.id}>
                        <div className="feedback-card">
                          <div className="author-name">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                              }}
                            >
                              <div
                                style={{
                                  width: "45px",
                                  height: "45px",
                                  borderRadius: "50%",
                                  backgroundColor: getAvatarColor(review.title),
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#fff",
                                  fontWeight: "600",
                                  fontSize: "18px",
                                  textTransform: "uppercase",
                                }}
                              >
                                {getInitials(review.title)}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "4px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "4px",
                                    color: "#fbbf24",
                                    fontSize: "14px",
                                  }}
                                >
                                  <FiStar fill="#fbbf24" />
                                  <FiStar fill="#fbbf24" />
                                  <FiStar fill="#fbbf24" />
                                  <FiStar fill="#fbbf24" />
                                  <FiStar fill="#fbbf24" />
                                </div>
                                <h6 style={{ margin: 0 }}>{review.title}</h6>
                              </div>
                              <div
                                className="logo"
                                style={{ marginLeft: "auto" }}
                              >
                                <img
                                  src="assets/img/home1/icon/google3.svg"
                                  alt
                                />
                              </div>
                            </div>
                          </div>
                          <p>{review.description}</p>
                        </div>
                      </SwiperSlide>
                    ))
                  )}
                </Swiper>
                <div className="row ">
                  <div className="col-lg-12 divider">
                    <div className="slider-btn-group style-2 justify-content-md-between justify-content-center">
                      <div
                        className="slider-btn prev-4 d-md-flex d-none"
                        ref={feedbackPrevRef}
                      >
                        <svg
                          width={11}
                          height={19}
                          viewBox="0 0 8 13"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M0 6.50008L8 0L2.90909 6.50008L8 13L0 6.50008Z" />
                        </svg>
                      </div>
                      <div
                        className="slider-btn next-4 d-md-flex d-none"
                        ref={feedbackNextRef}
                      >
                        <svg
                          width={11}
                          height={19}
                          viewBox="0 0 8 13"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M8 6.50008L0 0L5.09091 6.50008L0 13L8 6.50008Z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="news-section five mt-4 mb-4">
        <div className="container">
          <div className="row mb-50 " data-aos="fade-up" data-aos-delay="200">
            <div className="col-lg-12 d-flex align-items-end justify-content-between flex-wrap gap-4">
              <div className="section-title-2">
                <h2>The Latest Insight</h2>
                <p>
                  Read expert photography tips, milestone guides, and baby photography insights from our team.
                </p>
              </div>
              <div className="explore-btn d-lg-flex d-none">
                <Link to="/blogs" className="explore-btn2 two">
                  Explore More <i className="bi bi-arrow-right-short" />
                </Link>
              </div>
            </div>
          </div>
          <div className="row g-4 justify-content-center">
            {blogsData.slice(0, 3).map((blog, idx) => (
              <div
                key={blog.id}
                className="col-lg-4 col-md-6 "
                data-aos="fade-up"
                data-aos-delay={(idx + 2) * 100}
              >
                <div className="news-card">
                <div className="news-img" style={{ height: "240px", overflow: "hidden" }}>
                                          <Link to={`/blogs/${blog.slug}`}>
                                            <img src={blog.image} alt={blog.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                          </Link>
                    <div className="date">
                      <Link to="/blogs">{blog.category}</Link>
                    </div>
                  </div>
                  <div className="content">
                    <h6>
                      <Link to={`/blogs/${blog.slug}`}>
                        {blog.title}
                      </Link>
                    </h6>
                    <div className="news-btm">
                      <div className="author-area">
                        <div className="author-img">
                          <img src="/assets/img/logo.png" alt="Baby Twinkles" style={{ width: "38px", height: "38px", backgroundColor: "black", objectFit: "contain" }}  />
                        </div>
                        <div className="author-content">
                          <h6>Baby Twinkles</h6>
                          <Link to={`/blogs/${blog.slug}`}>
                            Posted on - {blog.date}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="faq-inquiery-form pt-4 pb-4">
        <div className="form-img d-xl-flex d-none">
          <img src="assets/img/inner-page/inquiery-form-img.png" alt />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xl-7">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <div className="form-inner mb-3">
                      <label>Name*</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder="Enter Your Name"
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="form-inner mb-3">
                      <label>Phone*</label>
                      <input
                        type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        placeholder="Enter Your Phone"
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="form-inner mb-3">
                      <label>Location*</label>
                      <input
                        type="text"
                        name="location"
                        value={formData.location}
                        onChange={handleChange}
                        required
                        placeholder="Enter Your Location"
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="form-inner mb-3">
                      <label>
                        Email <span>(Optional)</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Enter Your Email"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-inner mb-3">
                      <label>Description</label>
                      <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        placeholder="Write Something..."
                      />
                    </div>
                  </div>
                  <div className="col-md-12 text-center ">
                    <div className="col-md-12">
                      <div className="form-inner">
                        <button type="submit" className="primary-btn3">
                          Submit Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
      )}
    </>
  );
};

export default Home;
